// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VpdTq","left":"styles_left__6PK5D","right":"styles_right__29iyK","alert":"styles_alert__1JquE"};